/**
 * 계약자 정보 수정 컴포넌트
 * 계약의 신청자 정보를 수정하는 컴포넌트입니다.
 * 회원번호, 휴대폰, 이메일, 신청자명 등의 정보를 조회하고 수정할 수 있습니다.
 */

import _ from "lodash";
import { useEffect, useState } from "react";
import { Contractor } from "src/api/contract/contract-types";
import { BaseButton, BaseInput } from "src/components";
import SearchMemberPopup from "src/pages/commonPopup/SearchMemberPopup";
import { formatPhoneNumber } from "src/utils/common-util";
import BaseSection from "../../../../components/layout/BaseSection";

/**
 * 계약자 정보 수정 컴포넌트의 props 인터페이스
 */
interface ContractBasicProp {
  saveData?: any; // 저장할 데이터
  setSaveData?: any; // 저장 데이터 설정 함수
}

/**
 * 계약자 정보 수정 컴포넌트
 * @param detailData 상품 상세 조회 정보
 * @param saveData 저장할 데이터
 * @param setSaveData 저장 데이터 설정 함수
 */
const ContractorInfoEdit = ({ saveData, setSaveData }: ContractBasicProp) => {
  const [mflag, setMflag] = useState(false); // 회원 검색 팝업 표시 여부
  const [member, setMemeber] = useState<Contractor>(); // 회원 정보

  /**
   * 회원 정보 조회 팝업 표시
   */
  const onCheckMemberInfo = () => {
    setMflag(true);
  };

  /**
   * 회원 정보 변경 처리
   * @param member 변경할 회원 정보
   */
  const onChangeMember = (member: any) => {
    setMemeber(member);
    const temp = _.cloneDeep(saveData);
    temp.applicantMobile = member.phoneNumber;
    temp.email = member.email;
    temp.applicantMemberNo = member.memberNo;
    temp.applicantName = member.nickname;

    setSaveData(temp);
    setMflag(false);
  };

  // 저장 데이터가 변경될 때마다 회원 정보 업데이트
  useEffect(() => {
    if (saveData) {
      const temp = _.cloneDeep(saveData);
      let mem = {
        phoneNumber: temp.applicantMobile,
        memberNo: temp.applicantMemberNo,
        nickname: temp.applicantName,
        email: temp.email,
      };
      setMemeber(mem);
    }
  }, [saveData]);

  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <h2>신청정보</h2>
      </div>
      <div className="flex-center">
        <BaseSection
          title="회원번호"
          required={true}
          children={
            <div className="flex-row flex-center-start">
              {member?.memberNo && (
                <div className="minmax140 mr10">
                  <p>{member?.memberNo}</p>
                </div>
              )}
              <BaseButton
                title={member?.memberNo ? "변경" : "선택"}
                onClick={() => onCheckMemberInfo()}
                className="color-white"
                disabled={saveData.productId === undefined || saveData.productId === 0}
              />
              {mflag && <SearchMemberPopup isOpen={mflag} memberInfo={member} onClick={onChangeMember} onClose={() => setMflag(false)} />}

              {/* 컨트롤 룸은 memberNo로 체크한다. */}
              <p className="text-red600 font12">
                {/* {memberInfo?.id === undefined && errors?.contractMember?.memberNo && errors?.contractMember?.memberNo.message} */}
              </p>
            </div>
          }
        />

        <BaseSection
          title="휴대폰"
          value={member?.phoneNumber !== undefined ? formatPhoneNumber(decodeURIComponent(String(member?.phoneNumber))) : "-"}
        />
      </div>
      <div className="flex-center">
        <BaseSection title="이메일" value={member?.email !== undefined ? decodeURIComponent(String(member?.email)) : "-"} />
        <BaseSection
          title="신청자명"
          children={
            <div className="minmax160">
              {member?.memberNo !== undefined ? (
                <BaseInput
                  name={"applicantName"}
                  value={saveData.applicantName}
                  onChange={(value: string) => {
                    const temp = _.cloneDeep(saveData);
                    temp.applicantName = value;
                    setSaveData(temp);
                  }}
                />
              ) : (
                "-"
              )}
            </div>
          }
        />
      </div>
    </article>
  );
};

export default ContractorInfoEdit;
